export var Inline = function Inline(options) {
  var value = options.value;
  return function () {
    return value;
  };
};
Inline.props = {};